module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light featured"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "products-featured"
  }, [_c('h2', [_vm._v("Ideal für jede Party!\n                "), _c('span', [_vm._v("Zissel ist Partykult!")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-box"
  }, [_c('div', {
    staticClass: "featured-item"
  }, [_c('div', {
    staticClass: "featured-item__bottle"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/grapefruit-bottle.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "featured-item__fruit",
    attrs: {
      "src": "assets/img/grapefruit-fruit.png",
      "alt": "Grapefruit"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Zissel Grapefruit")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-item"
  }, [_c('div', {
    staticClass: "featured-item__bottle"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/lemon-bottle.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "featured-item__fruit",
    attrs: {
      "src": "assets/img/lemon-fruit.png",
      "alt": "Grapefruit"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Zissel Lemon")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-item"
  }, [_c('div', {
    staticClass: "featured-item__bottle"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/cactus-bottle.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "featured-item__fruit",
    attrs: {
      "src": "assets/img/cactus-fruit.png",
      "alt": "Grapefruit"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Zissel Kaktusfeige")])])]), _vm._v(" "), _c('div', {
    staticClass: "featured-description"
  }, [_c('span', {
    staticClass: "description-sticker"
  }, [_vm._v("Neu!")]), _vm._v(" "), _c('p', [_vm._v("\n                    Prickelnd leicht, fruchtig frisch und exotisch herb sind\n                    unsere Hefemixgetränke mit "), _c('b', [_vm._v("Grapefruit-, Lemon- oder Kaktusfeigensaft.")]), _vm._v("\n                    Genießt den unverwechselbaren Mix!\n                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txt-sm"
  }, [_vm._v("Biermischgetränk aus 50 % Hefeweizen und 50 % Fruchtsaft, Alkoholgehalt vol % 2,5")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45b78e9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/partials/featured-products.vue
// module id = 30
// module chunks = 0